import { render, staticRenderFns } from "./ShopAdminDashboardLayout.vue?vue&type=template&id=6fee0994&"
import script from "./ShopAdminDashboardLayout.vue?vue&type=script&lang=js&"
export * from "./ShopAdminDashboardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports